const makeFloor = (floor: string) =>
  floor === '0' ? 'Térreo' : `${floor}° andar`;
export default makeFloor;
